(function () {
  'use strict';
  if (window.FrageSprung) return;

  function kennung(text) {
    return String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 70);
  }
  function sauber(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }

  function sammeln(doc) {
    var liste = [];
    doc.querySelectorAll('details.fqb__eintrag, .fkt details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (!s) return;
      var inhalt = d.querySelector('.fqb__antwort, .details-content');
      liste.push({ frage: sauber(s.textContent), antwort: sauber(inhalt ? inhalt.textContent : ''), ziel: d,
        oeffnen: function () { d.open = true; } });
    });
    doc.querySelectorAll('.wfk').forEach(function (k) {
      var f = k.querySelector('.wfk__frage, .wfk__text .text-block');
      var knopf = k.querySelector('.wfk__auf');
      var feld = knopf && doc.getElementById(knopf.getAttribute('aria-controls'));
      var a = feld ? feld.querySelector('.wfp__antwort, .wfp__leib') : null;
      var frage = sauber(f ? f.textContent : '');
      liste.push({ frage: frage, antwort: sauber(a ? a.textContent.replace(frage, '') : ''), ziel: k,
        oeffnen: function () { if (knopf && knopf.getAttribute('aria-expanded') !== 'true') knopf.click(); } });
    });
    doc.querySelectorAll('details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (!s || !/fragen/i.test(s.textContent) || d.matches('.fqb__eintrag') || d.closest('.fkt')) return;
      d.querySelectorAll('p').forEach(function (p) {
        var b = p.querySelector('b, strong');
        if (!b || p.firstElementChild !== b) return;
        var frage = sauber(b.textContent);
        liste.push({ frage: frage, antwort: sauber(p.textContent).replace(frage, '').trim(), ziel: p,
          oeffnen: function () { d.open = true; } });
      });
    });
    return liste.filter(function (e) { return e.frage; });
  }

  function springen() {
    var m = /^#frage-(.+)$/.exec(location.hash || '');
    if (!m) return;
    var ziel = decodeURIComponent(m[1]);
    var treffer = sammeln(document).filter(function (e) { return kennung(e.frage) === ziel; })[0];
    if (!treffer) return;
    treffer.oeffnen();
    setTimeout(function () {
      treffer.ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      treffer.ziel.classList.add('frage-treffer');
      setTimeout(function () { treffer.ziel.classList.remove('frage-treffer'); }, 2000);
    }, 150);
  }

  window.FrageSprung = { kennung: kennung, sammeln: sammeln, springen: springen };

  var stil = document.createElement('style');
  stil.textContent = '.frage-treffer{background:var(--3idee-surface-soft,#f7f7f5);transition:background .4s;border-radius:var(--3idee-radius-klein,8px)}';
  document.head.appendChild(stil);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(springen, 300); });
  else setTimeout(springen, 300);
  window.addEventListener('hashchange', springen);
})();
